export const GET_ANALYTICS = "GET_ANALYTICS"
export const GET_ANALYTICS_SUCCESS = "GET_ANALYTICS_SUCCESS"
export const GET_ANALYTICS_ERROR = "GET_ANALYTICS_ERROR"
export const RESET_ANALYTICS = "RESET_ANALYTICS"

export const GET_CALL_OPPORTUNITIES = "GET_CALL_OPPORTUNITIES"
export const GET_CALL_OPPORTUNITIES_SUCCESS = "GET_CALL_OPPORTUNITIES_SUCCESS"
export const GET_CALL_OPPORTUNITIES_ERROR = "GET_CALL_OPPORTUNITIES_ERROR"

export const GET_ANALYTICS_EXPORT = "GET_ANALYTICS_EXPORT"
export const GET_ANALYTICS_EXPORT_SUCCESS = "GET_ANALYTICS_EXPORT_SUCCESS"
export const GET_ANALYTICS_EXPORT_ERROR = "GET_ANALYTICS_EXPORT_ERROR"
export const RESET_ANALYTICS_EXPORT_ERROR = "RESET_ANALYTICS_EXPORT_ERROR"

export const GET_CLICK_CONV_AGGR_ANALYTICS = "GET_CLICK_CONV_AGGR_ANALYTICS";
export const GET_CLICK_CONV_AGGR_ANALYTICS_SUCCESS = "GET_CLICK_CONV_AGGR_ANALYTICS_SUCCESS";
export const GET_CLICK_CONV_AGGR_ANALYTICS_ERROR = "GET_CLICK_CONV_AGGR_ANALYTICS_ERROR";

export const GET_CALL_CONV_AGGR_ANALYTICS = "GET_CALL_CONV_AGGR_ANALYTICS";
export const GET_CALL_CONV_AGGR_ANALYTICS_SUCCESS = "GET_CALL_CONV_AGGR_ANALYTICS_SUCCESS";
export const GET_CALL_CONV_AGGR_ANALYTICS_ERROR = "GET_CALL_CONV_AGGR_ANALYTICS_ERROR";

export const GET_LEAD_CONV_AGGR_ANALYTICS = "GET_LEAD_CONV_AGGR_ANALYTICS";
export const GET_LEAD_CONV_AGGR_ANALYTICS_SUCCESS = "GET_LEAD_CONV_AGGR_ANALYTICS_SUCCESS";
export const GET_LEAD_CONV_AGGR_ANALYTICS_ERROR = "GET_LEAD_CONV_AGGR_ANALYTICS_ERROR";

export const GET_ANALYTICS_COMPARE_TO_SUCCESS = "GET_ANALYTICS_COMPARE_TO_SUCCESS"
export const GET_CLICK_CONV_AGGR_ANALYTICS_COMPARE_TO_SUCCESS = "GET_CLICK_CONV_AGGR_ANALYTICS_COMPARE_TO_SUCCESS"
export const RESET_ANALYTICS_COMPARED_TO = "RESET_ANALYTICS_COMPARED_TO"

export const GET_CALL_OPPORTUNITIES_COMPARE_TO = "GET_CALL_OPPORTUNITIES_COMPARE_TO"
export const GET_CALL_OPPORTUNITIES_COMPARE_TO_SUCCESS = "GET_CALL_OPPORTUNITIES_COMPARE_TO_SUCCESS"
export const GET_CALL_OPPORTUNITIES_COMPARE_TO_ERROR = "GET_CALL_OPPORTUNITIES_COMPARE_TO_ERROR"
